import { cn } from "@core/utils/cn";
import { cva, type VariantProps } from "class-variance-authority";
import type { IconType } from "react-icons";

const badgeStyles = cva(
  "inline-flex items-center gap-2.5 h-8 px-2.5 rounded-lg overflow-hidden",
  {
    variants: {
      variant: {
        filled: "bg-accent-green-100 text-accent-green-800",
        outline:
          "border border-accent-green-200 text-accent-green-800 bg-transparent",
      },
    },
    defaultVariants: {
      variant: "filled",
    },
  },
);

type BadgeProps = VariantProps<typeof badgeStyles> & {
  title?: string | number;
  onlyIcon?: boolean;
  leftIcon?: IconType | string;
  rightIcon?: IconType | string;
  iconStroke?: number;
  // custom color overrides (CSS values, e.g. "#ff0000" or "var(--color-accent-red-100)")
  background?: string;
  color?: string;
  className?: string;
};

const Badge = ({
  title,
  variant,
  onlyIcon = false,
  leftIcon: LeftIcon,
  rightIcon: RightIcon,
  iconStroke = 1,
  background,
  color,
  className,
}: BadgeProps) => {
  return (
    <div
      style={
        background || color ? { backgroundColor: background, color } : undefined
      }
      className={cn(badgeStyles({ variant }), className)}
    >
      {LeftIcon && <LeftIcon strokeWidth={iconStroke} />}
      {!onlyIcon && title !== undefined && (
        <span className="text-xs">{title}</span>
      )}
      {RightIcon && <RightIcon strokeWidth={iconStroke} />}
    </div>
  );
};

export default Badge;
